import React from 'react';
import { NavigationIcon } from 'lucide-react';
export function Footer() {
  return <footer className="w-full border-t border-line bg-white" data-id="element-71" data-mp="3gfsoch60l2p3">
      <div className="mx-auto flex w-full max-w-6xl flex-col items-center justify-between gap-6 px-5 py-10 sm:flex-row sm:px-8" data-id="element-72" data-mp="3ghc0pwojutll">
        <a href="#top" className="flex items-center gap-2 font-extrabold text-ink" data-id="element-73" data-mp="36p6aoshuym91">
          <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-ink text-white" data-id="element-74" data-mp="3uf0nxb63actt">
            <NavigationIcon className="h-4 w-4" data-id="element-75" data-mp="38qtqszerhoj" />
          </span>
          <span className="text-lg tracking-tight" data-id="element-76" data-mp="37xxily2sakn">GPS Journal</span>
        </a>

        <nav className="flex items-center gap-6 text-sm font-medium text-muted" data-id="element-77" data-mp="3ldkep6r0ggr6">
          <a href="#how-it-works" className="hover:text-ink" data-id="element-78" data-mp="3qcnh0jflw8vg">How it works</a>
          <a href="#features" className="hover:text-ink" data-id="element-79" data-mp="29zgkbzgigqll">Features</a>
          <a href="#faqs" className="hover:text-ink" data-id="element-80" data-mp="2a19uhoqc1syc">FAQs</a>
        </nav>

        <p className="text-sm text-muted" data-id="element-81" data-mp="2ezuvvrhbmiod">© {new Date().getFullYear()} GPS Journal</p>
      </div>
    </footer>;
}